import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCharacterGenders', 'characterGenders'),
}
